/* ds-pick.js: a Dermastamp csomag-valaszto (snippets/ds-pick.liquid), 2026-10-18.
   A kartya a form rejtett items[] mezoit allitja; az ar, a pont, a Klarna-harmad es a gomb-felirat
   a Liquidben elore renderelt data-* ertekekbol jon (nincs JS-oldali penz-formazas).
   ?cel=akneheg|ranc|hajhullas|proba kijeloli a kartyat (a LED-oldal ?csomag= mintajara). */
(function () {
  if (window.__dsPickLoaded) return;
  window.__dsPickLoaded = true;

  /* a pont FORINTBAN merodik: nem-HUF penznemnel ugyanaz az atszamitas, mint a ds-pts-fx-ben */
  function ptsOf(minor, rate, hufPts) {
    var c = window.Shopify && Shopify.currency, r = c && parseFloat(c.rate);
    if (!c || !c.active || c.active === 'HUF' || !(r > 0)) return hufPts;
    return Math.floor(minor / 100 / r * rate / 100);
  }
  function num(n) { try { return n.toLocaleString(document.documentElement.lang || 'hu-HU'); } catch (e) { return String(n); } }

  function init(pk) {
    var form = pk.closest('form'); if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    var id = pk.querySelector('[data-pk-id]'), plan = pk.querySelector('[data-pk-plan]');
    var id2 = pk.querySelector('[data-pk-id2]'), q2 = pk.querySelector('[data-pk-q2]');
    var cen = pk.querySelector('[data-pk-cen]'), add = pk.querySelector('[data-add]');
    var box = pk.querySelector('[data-pk-pricebox]');
    var cards = pk.querySelectorAll('.pk__c');
    var label0 = btn ? btn.textContent.trim() : '';

    function upd() {
      var inp = pk.querySelector('.pk__c input:checked');
      var c = inp ? inp.closest('.pk__c') : null, k = c ? c.dataset.k : '';
      /* Osszevont elofizetes-kartya (2026-10-29): kijelolve a valasztott gyakorisagot mutatja, kulonben a 4/8-as alapszoveget. */
      var hc = pk.querySelector('.pk__c[data-k="haj"]');
      if (hc && hc.dataset.gStrip) {
        var fr = pk.querySelector('input[name^="pk-fq"]:checked');
        if (k === 'haj' && fr) setFq(fr);
        else {
          var y = hc.querySelector('[data-pk-strip]'); if (y) y.textContent = hc.dataset.gStrip;
          y = hc.querySelector('[data-pk-dur]'); if (y) y.textContent = hc.dataset.gDur;
          y = hc.querySelector('[data-pk-per]'); if (y) y.textContent = hc.dataset.gPer;
        }
      }
      pk.classList.toggle('has-sel', !!c);
      for (var i = 0; i < cards.length; i++) cards[i].classList.toggle('is-on', cards[i] === c);
      pk.querySelectorAll('[data-d]').forEach(function (d) { d.hidden = d.dataset.d !== k; });
      pk.querySelectorAll('[data-g]').forEach(function (g) { g.classList.toggle('is-on', g.dataset.g === k); });
      if (add) { add.hidden = !c || k === 'haj'; add.classList.toggle('is-on', !!(cen && cen.checked)); }
      if (!c) { box.hidden = true; if (btn) btn.textContent = label0; return; }
      var on = !!(cen && cen.checked && k !== 'haj' && c.dataset.priceC);
      var d = c.dataset;
      /* 12 + Centella: KET sor (a kedvezmeny a kosarban jon); 4 db + Centella: a mikrotuzes-rutin csomag */
      id.value = on && !d.add2 ? d.idC : d.id;
      plan.value = d.plan || ''; plan.disabled = !d.plan;
      var two = on && !!d.add2; id2.disabled = !two; q2.disabled = !two;
      var price = on ? d.priceC : d.price;
      box.hidden = false;
      pk.querySelector('[data-pk-price]').textContent = price;
      var sub = pk.querySelector('[data-pk-sub]'); sub.textContent = (on ? d.subC : d.sub) || ''; sub.hidden = !sub.textContent;
      pk.querySelector('[data-pk-pts]').textContent = num(ptsOf(+(on ? d.minorC : d.minor), +d.rate, +(on ? d.ptsC : d.pts)));
      if (btn && !btn.disabled) btn.textContent = d.cta + ' · ' + price;
    }

    function pick(k, push) {
      var inp = pk.querySelector('.pk__c[data-k="' + k + '"] input');
      if (!inp) return false;
      inp.checked = true; upd();
      if (push) try { var u = new URL(location.href); u.searchParams.set('cel', inp.closest('.pk__c').dataset.q); history.replaceState(history.state, '', u); } catch (e) {}
      return true;
    }

    /* 4 / 8 hetente a Hajhullas-kartyan: a kartya plan/ar/csik mezoit irja at, a kijelolest nem bantja */
    function setFq(r) {
      var hc = pk.querySelector('.pk__c[data-k="haj"]'); if (!hc) return;
      hc.dataset.plan = r.dataset.plan; hc.dataset.price = r.dataset.price;
      var x = hc.querySelector('[data-pk-per]'); if (x) x.textContent = r.dataset.per;
      x = hc.querySelector('[data-pk-strip]'); if (x) x.textContent = r.dataset.strip;
      /* Codex-audit F09 (2026-10-24): az alkalom-sor, az i-info es az elofizetes-panel (ds-pdpv2) is a valasztott
         utemezest mondja, ne maradjon 4 hetes a 8 hetes valasztas mellett. */
      x = hc.querySelector('[data-pk-dur]'); if (x && r.dataset.dur) x.textContent = r.dataset.dur;
      x = hc.querySelector('[data-pk-info]'); if (x && r.dataset.info) x.textContent = r.dataset.info;
      document.querySelectorAll('[data-pk-fqtxt]').forEach(function (t) { t.hidden = t.getAttribute('data-pk-fqtxt') !== r.value; });
    }

    pk.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('pk-fq') === 0) { setFq(e.target); upd(); return; }
      if (e.target.type === 'radio') pick(e.target.value, true); else upd();
    });
    pk.querySelectorAll('.pk__i').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var inf = document.getElementById(b.getAttribute('aria-controls')), open = inf.hidden;
        inf.hidden = !open; b.setAttribute('aria-expanded', String(open));
      });
    });
    pk.querySelectorAll('.pk__info').forEach(function (x) {
      x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    });
    /* Nincs eroltetett alapertelmezes: ha valasztas nelkul nyomja meg a gombot, a Kiprobalasra kerul a kosarba
       (a rejtett mezok mar ezt hordozzak), es a kartya ezt meg is mutatja. A form sajat listenere a
       document-szintu ajax-add-to-cart ELOTT fut. */
    form.addEventListener('submit', function () { if (!pk.querySelector('.pk__c input:checked')) pick('proba', false); });

    var want = '';
    try { want = new URLSearchParams(location.search).get('cel') || ''; } catch (e) {}
    var map = { akneheg: 'akne', akne: 'akne', ranc: 'akne', hajhullas: 'haj', haj: 'haj', proba: 'proba' };
    if (!(map[want] && pick(map[want], false)) && pk.dataset.sel) pick(pk.dataset.sel, false);
    upd();
  }

  function boot() { document.querySelectorAll('[data-pk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
